import React from "react";
import { ArrowRight } from "lucide-react";

/**
 * FinalCTABanner — Full-width closing banner. Gold-accented on obsidian
 * with a single Calendly CTA. Rendered just above the site footer.
 */
const CALENDLY_URL = "https://calendly.com/empowerinvestgrow/30min";
const GOLD = "#C9A84C";

export default function FinalCTABanner() {
    return (
        <section
            id="final-cta"
            data-testid="final-cta-section"
            className="relative py-20 md:py-24 overflow-hidden"
            style={{
                background:
                    "linear-gradient(135deg, #0A0A0A 0%, #1A1508 55%, #0A0A0A 100%)",
                borderTop: "1px solid rgba(201,168,76,0.35)",
                borderBottom: "1px solid rgba(201,168,76,0.35)",
            }}
        >
            {/* Gold wash */}
            <div
                aria-hidden="true"
                className="absolute inset-0 pointer-events-none"
                style={{
                    background:
                        "radial-gradient(ellipse at center, rgba(201,168,76,0.14) 0%, transparent 55%)",
                }}
            />
            <div className="max-w-[1200px] mx-auto px-6 md:px-10 relative">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
                    <h2
                        className="text-3xl md:text-4xl leading-[1.15] tracking-tight max-w-2xl"
                        style={{
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 700,
                            color: "#EDEDED",
                            letterSpacing: "-0.02em",
                        }}
                        data-testid="final-cta-heading"
                    >
                        Ready to upgrade your{" "}
                        <span style={{ color: GOLD }}>business infrastructure?</span>
                    </h2>
                    <a
                        href={CALENDLY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-cta-button"
                        className="group inline-flex items-center gap-2 px-8 py-4 font-bold uppercase tracking-[0.22em] text-sm transition-all duration-300 whitespace-nowrap"
                        style={{
                            background: GOLD,
                            color: "#0A0A0A",
                            border: `1px solid ${GOLD}`,
                            fontFamily: "'Montserrat', sans-serif",
                            boxShadow: "0 0 24px rgba(201,168,76,0.35)",
                            borderRadius: "8px",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = "0 0 40px rgba(201,168,76,0.65)";
                            e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = "0 0 24px rgba(201,168,76,0.35)";
                            e.currentTarget.style.transform = "translateY(0)";
                        }}
                    >
                        Book Your Strategy Call
                        <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                    </a>
                </div>
            </div>
        </section>
    );
}
